import { EMessagesActionTypes } from '../../actions/messages';
import { EUnreadMessagesStatus, IMessagesState } from '../../types/messages';
import { TReduxActions } from '../../types/redux';

const defaultState: IMessagesState = {
  count: 0,
  status: EUnreadMessagesStatus.Initial,
};

export function messagesReducer(state: IMessagesState = defaultState, action: TReduxActions): IMessagesState {
  switch (action.type) {
    case EMessagesActionTypes.LoadingUnreadMessages:
      return {
        ...state,
        status: EUnreadMessagesStatus.Loading,
        activeRequestId: action.payload.requestId,
      };

    case EMessagesActionTypes.LoadedUnreadMessages:
      if (state.activeRequestId !== action.payload.requestId) {
        return state;
      }

      return {
        count: action.payload.count,
        status: EUnreadMessagesStatus.Succeed,
        activeRequestId: undefined,
      };

    case EMessagesActionTypes.FailedUnreadMessages:
      if (state.activeRequestId !== action.payload.requestId) {
        return state;
      }

      return {
        ...state,
        status: EUnreadMessagesStatus.Failed,
        activeRequestId: undefined,
      };

    case EMessagesActionTypes.ResetUnreadMessages:
      return {
        count: 0,
        status: EUnreadMessagesStatus.Initial,
        activeRequestId: undefined,
      };

    case EMessagesActionTypes.UpdateCount:
      return {
        count: action.payload,
        status: EUnreadMessagesStatus.Succeed,
        activeRequestId: undefined,
      };
    default:
      return state;
  }
}
